import axios from 'axios';
import StorageService from './StorageService';

const CK_API = process.env.REACT_APP_UPLOAD_URL;

class CkService {
  constructor() {
  
    this.client = axios.create({
      baseURL: CK_API,
      timeout: 60000,
      headers: {
        'Accept': '*/*',
        'Content-Type': 'multipart/form-data'
      }
    });
    
  }

  upload(url, data){
    delete axios.defaults.headers.common["Authorization"];
    
    return this.client.post(url, data);
  }
}

export default new CkService()
